// extracted by mini-css-extract-plugin
module.exports = {"text":"components-DeleteUser-DeleteUser__text--3VZsH","cancelButton":"components-DeleteUser-DeleteUser__cancelButton--PcegV"};